import { HostListener, Injectable } from '@angular/core';
import {
  Chat,
  Contact,
  IMessengerConnector,
  Message,
  Profile,
  ResultChatDetail,
  ResultHistory,
  SendMessage
} from '../types/all.type';
import { environment } from '../../environments/environment';
import {
  BehaviorSubject,
  interval,
  mergeMap,
  Observable, of,
  ReplaySubject,
  startWith,
  Subject,
  Subscription,
  throttleTime,
  timeout, timer
} from 'rxjs';
import { NotifierWrapService } from './notifier-wrap.service';
import { AllService } from './all.service';
import { TelegramService } from '../pages/page-telegram/telegram.service';
import { SnotifyPosition, SnotifyService } from 'ng-snotify';
import { WhatsappService } from '../pages/page-whatsapp/whatsapp.service';
import { InterfaceService } from './interface.service';
import { ModalService } from './modal.service';
import { FellowdeskService } from '../pages/page-fellowdesk/fellowdesk.service';
import { HttpClient } from '@angular/common/http';
import { SenderAccount, SenderAccountToken, SenderHistoryResults } from '../types/sende.type';
import { AbstractControl, UntypedFormControl, UntypedFormGroup, ValidationErrors, Validators } from '@angular/forms';
import { AllMessengersService } from '../pages/page-start/all-messengers.service';
import { DatePipe } from '@angular/common';
import { AppService } from './app.service';
import { concatMap, debounceTime, distinctUntilChanged, filter, first } from 'rxjs/operators';
import { log } from '../functions';
import { ShepherdService } from 'angular-shepherd';
import { ActivatedRoute } from '@angular/router';
import { DcService } from './dc.service';
import { AuthService } from '../modules/auth/services/auth.service';
import { ToursService } from './tours.service';
import { PromoCodes } from "../types/lead.type";

declare var ym: any;

@Injectable({
  providedIn: 'root'
})
export class SenderService implements IMessengerConnector {
  public nemuAccounts: IMessengerConnector[] = [];
  public disabledMessageTextarea = true;
  public helpChatUserName = 'coscosang';
  public helpChatId = 5988896533;
  public excludeDomains = [];
  chatInfo: ResultChatDetail | null = null;
  loadedChatDetail = false;
  errorChatDetail: string | undefined;
  errorPostLinkDetail: string | undefined;
  noHistoryCache = true;
  messageInputText = 'Введите текст рассылки';
  status = true;
  public loadHistoryError: boolean | any = false;
  public type = 'sender';
  public name = 'Sender';
  public unreadCount = 0;
  public _openChat: Chat;
  public openChat: Chat;
  public arLocalHistory: any = {};
  public environment = environment;
  public urlApi: any = environment.sender;
  public urlApiFileUpload: string = environment.tg + '/api/file/';
  public arChat: Chat[] = [];
  public _openChatId: any;
  public arProfile: Profile = {} as Profile;
  public setLocalHistory$: ReplaySubject<{
    id: string | number, arHistory: Message[]
  }> = new ReplaySubject();
  public Service: IMessengerConnector;
  arHistory: Message[] = [];
  public replyMessage: false | Message;
  public forwardMessage: Message | false = false;
  public editMessage: false | Message;
  bufferMessage: string;
  message = '';
  isLoadedProfile = true;
  isLoadedProfileError: boolean;
  reloadRequestsSubscription: Subscription;

  arTyping: any = [];
  arVisibleStickers: any;
  isDeleteAllMessage: boolean;
  messageLastDate: number;
  token: string;
  promoCodes: PromoCodes = {VIKTOR: {type: 'percent', value: 50}};
  tariffPrice = 500;
  public arSale = {1: 0, 3: 10, 6: 20, 12: 30};
  senderForm: UntypedFormGroup;
  public account$: BehaviorSubject<SenderAccount> = new BehaviorSubject(undefined);
  public isOpenedAddBalance = false;
  isLoopEnable = false;
  parseType: 1 | 2 | 3 = 1;
  tabIndex = 0;
  isSending: boolean;
  public senderType = 2;
  public getProfile$: ReplaySubject<Profile> = new ReplaySubject();
  public setSenderTypes$: ReplaySubject<number | void> = new ReplaySubject();
  public _senderAddForm = true;
  public updateMessage$: Subject<Message> = new Subject();
  tourComplete = false;
  public messageErrorFillChat = 'Вставьте ссылку на канал/группу/чат, с открытым списком подписчиков.';
  public messageErrorFillLoop = 'Укажите временные интервалы и кол-во повторов.';
  public messageErrorFillPostLink = 'Укажите временные интервалы и кол-во повторов.';

  expiredTariff$: BehaviorSubject<boolean> = new BehaviorSubject(false);
  isCopyPartnerLink = false;

  constructor(
    private toursService: ToursService,
    private authService: AuthService,
    private dcService: DcService,
    private route: ActivatedRoute,
    public senderService: SenderService,
    public shepherdService: ShepherdService,
    public appService: AppService,
    public allMessengersService: AllMessengersService,
    private http: HttpClient,
    public interfaceService: InterfaceService,
    private snotifyService: SnotifyService,
    public modalService: ModalService,
    public allService: AllService,
    public telegramService: TelegramService,
    public whatsappService: WhatsappService,
    public notifierWrapService: NotifierWrapService,
    private datepipe: DatePipe
  ) {
    this.setPartnerId();
    this.updateAccount();
    this.updateHistory();

    this.account$.subscribe((account) => {
      if (account?.id) {
        this.ymAddParams();
        this.setVarLocal('account', account);
      }
      const val = this.expiredTariff(0);
      this.expiredTariff$.next(val);
      setTimeout(() => {
        if (
          !this.interfaceService.isLeadsDomain &&
          this.allMessengersService.arServicesAuthorized?.length > 0 &&
          !this.isOpenedAddBalance &&
          this.account$.value?.balance < 1 &&
          (this.senderService.tourComplete || !this.shepherdService.isActive)
        ) {
          this.isOpenedAddBalance = true;
          this.modalService.openModal('ModalAddBalanceComponent');
        }
      }, 9000);

    });
    const localAccount = this.getVarLocal('account', {});
    if (localAccount?.id) {
      this.account$.next(localAccount);
      this.wsConnect();
    }
    this.senderForm = new UntypedFormGroup({
      id: new UntypedFormControl(''),
      name: new UntypedFormControl(''),
      start_date: new UntypedFormControl(this.isoDate, Validators.required),
      total_send: new UntypedFormControl(0),
      contacts: new UntypedFormControl('', [Validators.minLength(5)]),
      loop_interval: new UntypedFormControl(0),
      loop_need_count: new UntypedFormControl(0),
      parsed_chat: new UntypedFormControl(''),
      post_link: new UntypedFormControl('', [
        Validators.pattern(/^https?:\/\/\S+$/i), // Простейшее регулярное выражение для URL,
        this.validatePostLink,
      ]),
    });
    this.senderForm.get('contacts').valueChanges.subscribe(contacts => {
      console.log('contacts valueChanges');
      if (this.senderType !== 3 && contacts?.length > 0) {
        const arContacts = contacts.split('\n').filter(v => v);
        this.senderForm.get('total_send').setValue(arContacts?.length);
        console.log(arContacts);
      } else {
        this.senderForm.get('total_send').setValue(0);
      }
    });
    this.interfaceService.$onEdtMessage.subscribe((type) => {
      this.tabIndex = this.senderType > -1 ? 1 : 0;
      if (type !== 'sender') {
        return;
      }
      if (this.editMessage) {
        this.isLoopEnable = this.editMessage.sender?.loop_interval > 0;
      }
      if (type === this.type && this.editMessage) {
        console.log('senderForm.patchValue', this.editMessage.sender);
        this.senderType = parseInt(this.editMessage.sender?.type, 10) || -1;
        this.senderForm.patchValue(this.editMessage.sender);
        let contacts = '';
        try {
          contacts = JSON.parse(this.editMessage.sender.contacts || '').join('\n');
        } catch (e) {
        }
        this.senderForm.get('contacts').setValue(contacts);
        this.senderForm.get('loop_interval').setValue((this.editMessage.sender.loop_interval || 0));
        const startDate = new Date(this.editMessage.sender.start_date).toISOString().slice(0, 16);
        this.senderForm.get('start_date').setValue(startDate);
      }
    });
    this.interfaceService.$onCancelEdtMessage.subscribe((type) => {
      this.senderForm.reset();
    });
    this.interfaceService.$onCancelAddSender.subscribe(() => {
      this.senderForm.reset();
    });

    this.setLocalHistory$.pipe(throttleTime(3000)).subscribe((data) => {
      this.setLocalHistory(data.id, data.arHistory);
    });
    this.setSenderTypes$.pipe(debounceTime(100)).subscribe(() => {

      if ((this.senderType === 3) && this.parseType === 1) {
        this.disabledMessageTextarea = true;
        this.senderForm.get('start_date').disable();
      } else {
        this.senderForm.get('start_date').enable();
        this.disabledMessageTextarea = false;
      }
      if (this.senderType === 2) {
        this.disabledMessageTextarea = true;
      }
      this.fixStartDate();
      this.dcService.detectChanges$.next('chat-show');
    });
    // this.logoutAccounts();
  }

  validatePostLink(control: AbstractControl): ValidationErrors | null {
    if (control.value && control.value.includes('t.me/c/')) {
      return {invalidLink: true};
    }
    return null;
  }

  setLocalHistory(id, arHistory: Message[]): void {
    if (!id) {
      return;
    }
    this.arLocalHistory[id] = arHistory;
    // localStorage.setItem('telegram_history', JSON.stringify(this.arLocalHistory));
    // this.setVarLocal('history', this.arLocalHistory);
  }

  saveMessage(arData: Message, arFiles: any = []): Observable<any> {
    return new Observable((observer) => {
      const value: any = {...this.senderForm.value};
      value.contacts = JSON.stringify(value.contacts.split('\n'));
      // value.attachments = JSON.stringify(value.attachments.split('\n'));
      value.text = this.clearHTML(arData.text);
      value.text_variations = JSON.stringify(this.textVariations);
      value.type = (this.senderType > 0 ? this.senderType : 0).toString();
      value.attachments = JSON.stringify(Object.keys(arFiles));
      value.is_banned = false;
      const id = value.id;
      delete value.id;
      console.log('value', value);
      this.http.put(`${this.urlApi}/api/sender/list/${id}/?account_id=${this.account$.value.id}`, value)
        .subscribe((data: any) => {
          const arMessage = this.convertSenderToMessage([data])[0];
          // console.log('saveMessage', data, arMessage);
          observer.next(arMessage);
          this.senderForm.reset();
          this.allMessengersService.resetTextVariations$.next();
          this.disabledMessageTextarea = false;
          observer.complete();
        });
    });
  }

  updateMessage(id: number | string): Observable<Message> {
    return new Observable((observer) => {
      this.http.get(`${this.urlApi}/api/sender/list/${id}/?account_id=${this.account$.value.id}`)
        .subscribe((data: SenderHistoryResults) => {
          const arMessage = this.convertSenderToMessage([data])[0];
          // alert(this.arHistory.find((v) => v.id = arMessage.id).sender.name)
          observer.next(arMessage);
          observer.complete();
        });
    });
  }

  get textVariations() {
    return this.allMessengersService.arTextVariations
      .filter((val, i) => i > 0 && val.text?.length > 10)
      .map((v) => {
        v.text = this.clearHTML(v.text);
        return v;
      });
  }

  clearHTML(html: string): string {
    return html.replace(/<[^>]+>/g, (match) => {
      return match.replace(/(\s+\w+(=["'][^"']*["'])?)+/g, '');
    }).replace(/<(?!\/?(b|i|em|strong|u|br)\b)[^>]+>/gi, '');
  }

  sendMessage(arData: SendMessage): Observable<Message[]> {
    this.isSending = true;

    // .import_contacts([
    //     InputPhoneContact("number", "name")]
    log('Send message attachments', arData.attachments);
    // https://docs.pyrogram.org/api/methods/add_contact
    return new Observable((observer) => {

      if (!this.account$.value?.id) {
        alert('Ошибка! Сбросьте куки и авторизуйтесь заново. Если не помогло, напишите нам.');
      }
      this.fixStartDate();
      if (this.validSenderForm) {
        const text = (!this.disabledMessageTextarea) ? this.clearHTML(arData.text) : '';
        if (!this.toursService.tourTextVariationsNotShow && this.textVariations?.length <= 1 && arData.text?.length > 50) {
          this.toursService.startVariationsTour$.next(0);
          this.isSending = false;
          observer.error({type: 'skip', message: 'Отправка рассылки прервана. что бы показать вам предупреждение.'});
          observer.complete();
          return;
        }

        const contacts = (this.senderForm.get('contacts').value || '').split('\n');
        const startDate = this.senderForm.get('start_date').value || this.isoDate;
        this.http.post(`${this.urlApi}/api/sender/list/`, {
          name: this.senderForm.get('name').value,
          attachments: JSON.stringify(arData.attachments),
          start_date: startDate,
          text,
          text_variations: JSON.stringify(this.textVariations),
          type: (this.senderType > 0 ? this.senderType : 0).toString(),
          contacts: JSON.stringify(contacts),
          current_count: 0,
          total_send: contacts?.length,
          end_date: startDate,
          account_id: this.account$.value?.id,
          loop_interval: this.senderForm.get('loop_interval').value,
          loop_need_count: this.senderForm.get('loop_need_count').value,
          parsed_chat: this.senderForm.get('parsed_chat').value,
          post_link: this.senderForm.get('post_link').value
        } as SenderHistoryResults).subscribe((arMessage: any) => {
          this.isSending = false;
          console.log(arMessage);
          observer.next(this.convertSenderToMessage([arMessage]));
          observer.complete();
          this.message = '';
          this.allMessengersService.resetTextVariations$.next();
          this.disabledMessageTextarea = false;

        }, error => {
          this.isSending = false;
          observer.error(error);
          observer.complete();
        });
      } else {
        if (!this._senderAddForm) {
          this.senderAddForm = true;
          this.isSending = false;
          observer.error({error: {error_msg: 'Заполните форму.'}});
          observer.complete();
          return;
        }
        Object.keys(this.senderForm.controls).forEach((controlName) => this.senderForm.controls[controlName].markAsTouched());
        console.log('senderForm', this.senderForm);
        if (!this.validLoop()) {
          this.tabIndex = 2;
          observer.error({error: {error_msg: this.messageErrorFillLoop}});
        } else if (!this.validContacts()) {
          this.tabIndex = 1;
          observer.error({error: {error_msg: 'Заполните список получателей.'}});
        } else if (!this.validChat) {
          this.tabIndex = 1;
          observer.error({error: {error_msg: this.messageErrorFillChat}});
        } else if (!this.validPost) {
          this.tabIndex = 2;
          observer.error({error: {error_msg: this.messageErrorFillPostLink}});
        } else {
          this.tabIndex = 2;
          observer.error({error: {error_msg: 'Заполните поля.'}});
        }
        this.isSending = false;
        observer.complete();
        this.dcService.detectChanges$.next('add-form-sender');
        return;
      }
    });
  }

  convertPartnerToMessage(arSenders: SenderAccount[]): Message[] {
    const arMessages: Message[] = [];
    arSenders.forEach((item) => {
      return arMessages.push({
        service: 'sender',
        id: item.id,
        chat_id: 'partner',
        date: Date.parse(''),
        out: true,
        text_list: '',
        text: '',
        partner: item,
      });
    });
    return arMessages;
  }

  convertSenderToMessage(arSenders: SenderHistoryResults[]): Message[] {
    const arMessages: Message[] = [];
    arSenders.forEach((item) => {
      return arMessages.push({
        service: 'sender',
        id: item.id,
        chat_id: 'sender',
        date: Date.parse(item.start_date),
        out: true,
        text_list: item.text,
        text: item.text,
        sender: item,
      });
    });
    return arMessages;
  }

  getHistorySenders(
    chatId: string | number,
    offsetId: string | number = 0,
    currentCount: number,
    limit = 15,
    cursor: any = {}
  ): Observable<ResultHistory> {
    return new Observable((observer) => {
      const page = Math.round(currentCount / limit) + 1;
      // console.log(currentCount, limit, cursor)
      this.http.get(`${this.urlApi}/api/sender/list/?page=${page}&ordering=-start_date&account_id=${this.account$.value.id}`)
        .subscribe((data: { results: SenderHistoryResults[] }) => {
          // console.log(data);
          const arMessages = this.convertSenderToMessage(data.results);

          observer.next({
            results: arMessages.reverse(),
            chat: {
              id: 'sender',
              type: 'channel',
              service_type: this.type,
              name: {
                first: 'Список',
                last: 'расылок'
              }
            }
          });
        }, error => {
          observer.error(error);
          observer.complete();
        });
    });
  }

  getHistoryPartner(
    chatId: string | number,
    offsetId: string | number = 0,
    currentCount: number,
    limit = 15,
    cursor: any = {}
  ): Observable<ResultHistory> {
    return new Observable((observer) => {
      const page = Math.round(currentCount / limit) + 1;
      // console.log(currentCount, limit, cursor)
      this.http.get(`${this.urlApi}/api/sender/partner/?page=${page}&ordering=-start_date&account_id=${this.account$.value.id}`)
        .subscribe((data: { results: SenderAccount[] }) => {
          // console.log(data);
          const arMessages = this.convertPartnerToMessage(data.results);
          console.log('!!!', arMessages);
          observer.next({
            results: arMessages.reverse(),
            chat: {
              id: 'partner',
              type: 'channel',
              service_type: this.type,
              name: {
                first: 'Список',
                last: 'пользователей'
              },
              permissions: {
                can_send_messages: false
              }
            }
          });
        }, error => {
          observer.error(error);
          observer.complete();
        });
    });
  }

  getHistory(
    chatId: string | number,
    offsetId: string | number = 0,
    currentCount: number,
    limit = 15,
    cursor: any = {}
  ): Observable<ResultHistory> {
    if (chatId === 'partner') {
      return this.getHistoryPartner(chatId, offsetId, currentCount, limit, cursor);
    } else {
      return this.getHistorySenders(chatId, offsetId, currentCount, limit, cursor);
    }
  }

  getUploadUrl(chatId, type = 'audio_message'): Observable<{ uploadUrl: string, method: 'post' | 'put' }> {
    return new Observable((observer) => {
      observer.next({uploadUrl: this.urlApiFileUpload, method: 'post'});
      observer.complete();
    });
  }

  addedFile(file: File): Observable<{ uploadUrl: string }> {
    return new Observable((observer) => {
      observer.next({uploadUrl: this.urlApiFileUpload});
      observer.complete();
    });
  }

  saveFile(file: File | Blob, title = '') {
    return new Observable((observer) => {
      observer.next(file[0]);
      observer.complete();
    }).pipe(first()); // , tag("saveFile")
  }

  logout(onlyToken: boolean): void {
    throw new Error('Method not implemented.');
  }

  addChatUser(chatId: string | number, userId: string | number): Observable<any> {
    throw new Error('Method not implemented.');
  }

  leaveChat(chat: Chat, del = false, envService: IMessengerConnector): Observable<any> {
    throw new Error('Method not implemented.');
  }


  chatList(filterType, offsetDate = 0): Observable<{ results: Chat[] }> {
    throw new Error('Method not implemented.');
  }

  readHistory(chatId, maxId: string | number): any {
    throw new Error('Method not implemented.');
  }

  toggleChatPine(id, pinned: boolean): any {
    throw new Error('Method not implemented.');
  }

  contactsList(q = '', online: any = '', count = 200): Observable<{ results: Chat[] | Contact[] }> {
    throw new Error('Method not implemented.');
  }


  errorHandling(error: any, isNotify?: boolean): string | void {
    return undefined;
  }

  get isAuth(): boolean {
    return false;
  }

  getVarLocal(name: string, defaultValue: any = {}) {
    try {
      return JSON.parse(localStorage.getItem('sender_' + name)) || defaultValue;
    } catch (e) {
      return defaultValue;
    }
  }

  setVarLocal(name: string, val: any): void {
    try {
      localStorage.setItem('sender_' + name, JSON.stringify(val));
    } catch (e) {
      console.error('setVarLocal error');
    }
  }

  sendKeyBoard(arData: any): Observable<any> {
    throw new Error('Method not implemented.');
  }

  getDetailInfo(id: any): Observable<any> {
    throw new Error('Method not implemented.');
  }

  chatSearch(id: any, f: string): Observable<any> {
    throw new Error('Method not implemented.');
  }

  getChatSearch(id: any, f: string, query: string, offset: number, limit: number): Observable<any> {
    throw new Error('Method not implemented.');
  }

  getGlobalSearch(query: string, limit: number): Observable<any> {
    throw new Error('Method not implemented.');
  }

  sendVoice(file: any, chatId: string | number): Observable<any> {
    throw new Error('Method not implemented.');
  }

  getFile(fileId: string, fileUniqueId: string, ungzip: boolean): Observable<any> {
    throw new Error('Method not implemented.');
  }

  getStickers(): Observable<any> {
    throw new Error('Method not implemented.');
  }

  getGifs(): Observable<any> {
    throw new Error('Method not implemented.');
  }

  deleteFile(uri: string): Observable<any> {
    return new Observable((observer) => {
      observer.next({});
      observer.complete();
    });
  }

  setNotify(arData: any): Observable<any> {
    throw new Error('Method not implemented.');
  }

  getNotify(peer: string | number, chat: Chat): Observable<any> {
    throw new Error('Method not implemented.');
  }

  getFileSrc(attachment: any): string {
    throw new Error('Method not implemented.');
  }

  getFile$(fileId: string, fileUniqueId: string, l = '') {
    throw new Error('Method not implemented.');
  }

  getThumbSrc(attachment: any): void {
    throw new Error('Method not implemented.');
  }

  loadAttachment$(attachment: any): Observable<any> {
    throw new Error('Method not implemented.');
  }

  loadAudio$(attachment: any): Observable<any> {
    throw new Error('Method not implemented.');
  }

  chatNew(title: string, arUsers: any): Observable<any> {
    throw new Error('Method not implemented.');
  }

  loadProfile(): Observable<any> {
    throw new Error('Method not implemented.');
  }

  getProfile(initiator = ''): Observable<Profile> {
    throw new Error('Method not implemented.');
  }

  forwardMessages(chatId: any, fromChatId: any, messages: Message[]): Observable<any> {
    throw new Error('Method not implemented.');
  }

  deleteMessages(chatId: any, revoke: boolean, messageIds: any): Observable<any> {
    throw new Error('Method not implemented.');
  }

  get openChatId() {
    return this._openChatId;
  }

  /*
    def get_chat_id(phone_num):
      temp_contact_name = tempfile.NamedTemporaryFile().name.split('\\')[-1]
    good_res = list()
    with app:
      app.import_contacts([InputPhoneContact(phone=phone_num, first_name=temp_contact_name)])
    contacts = app.get_contacts()
    for contact in contacts:
      contact_data = json.loads(str(contact))
    if contact_data['first_name'] === temp_contact_name:
      good_res.append(contact_data)
    app.delete_contacts(contact_data['id'])
    try:
      good_res = good_res[0]['id']
    except:
      good_res = None
    return good_res*/
  setAccount(account: SenderAccount, Service: IMessengerConnector | false = false): void {
    this.account$.next(account);
    this.wsConnect(Service);
  }

  wsConnect(Service: IMessengerConnector | false = false): void {
    // Если уже есть подключение, значит есть и аккаунт, просто инициализируем новый акккаунт
    if (this.allService.wsService.isConnected) {
      if (Service) {
        setTimeout(() => {
          const key = `init_app_handle`;
          this.telegramService.sendEvent(key, {
            token: Service.token,
            type: Service.type
          });
        }, 5000);
      }
    } else {
      this.allService.wsService.roomId = this.account$.value.id;
      this.allService.wsService.initConfig();
      this.allService.wsService.connect();
    }
  }

  get balanceColor(): string {
    if (this.account$.value.balance < 30) {
      return 'danger';
    } else if (this.account$.value.balance < 500) {
      return 'warning';
    } else if (this.account$.value.balance < 1000) {
      return 'info';
    }
    return 'success';
  }

  updateAccount(): void {
    // this.allService.isFocused()
    interval(15000)
      .pipe(
        filter(() => this.account$.value?.id > 0 && this.allMessengersService.arServicesAuthorized?.length > 0)
      )
      .subscribe(() => {
        this.http.get(`${this.urlApi}/api/sender/account/${this.account$.value.id}/`)
          .pipe(timeout(5000))
          .subscribe((account: SenderAccount) => {
            this.account$.next(account);
          });
      });
  }

  updateHistory(): void {
    interval(10000)
      .pipe(
        filter(() => !!this.account$.value?.id && this.openChatId === 'sender')
      )
      .subscribe(result => {
        let needUpdateChats = false;
        this.getHistory('', '', 0, 100, '')
          .pipe(timeout(5000))
          .subscribe((v) => {
            v.results.forEach((message) => {
              this.arHistory.filter((item) => item.id === message.id).map((val) => {
                if (val.sender.current_count !== message.sender.current_count) {
                  needUpdateChats = true;
                }
                Object.keys(message).forEach((key) => {
                  val[key] = message[key];
                });

              });
              this.updateMessage$.next(message);
            });
            if (needUpdateChats) {
              setTimeout(() => {
                this.interfaceService.reLoadChatsForce$.next();
              }, 30000);
            }
          }, error => {
          });
      });
  }

  get checkChatStatus(): string {
    if (this.senderForm.get('parsed_chat').invalid) {
      return 'warning';
    } else if (this.errorChatDetail) {
      return 'error';
    } else if (this.chatInfo?.chat?.type === 'private') {
      this.errorChatDetail = 'Вы ввели ссылку на пользователя, а не на чат.';
      return 'error';
    } else if (this.chatInfo?.chat?.type === 'bot') {
      this.errorChatDetail = 'Вы ввели ссылку на бота, а не на чат.';
      return 'error';
    } else if (this.chatInfo?.members?.length === 0) {
      this.errorChatDetail = 'У этого чата/канала скрыт список подписчиков.';
      return 'error';
    }
    return 'success';
  }

  get checkPostLinkStatus(): string {
    if (
      this.senderType === 2 &&
      (
        this.senderForm.get('post_link').invalid ||
        !this.senderForm.get('post_link').value
      )
    ) {
      if (this.senderForm.get('post_link').hasError('invalidLink')) {
        return 'error';
      }
      return 'warning';
    }
    return 'success';
  }

  public get validChat(): boolean {
    return this.checkChatStatus === 'success' || this.senderType !== 3;
  }

  public get validPost(): boolean {
    return this.checkPostLinkStatus === 'success';
  }

  public validLoop(): boolean {
    return (((this.senderForm.get('loop_interval').value) &&
      (this.senderForm.get('loop_need_count').value))) || !this.isLoopEnable;
  }

  public validContacts(): boolean {
    return (this.senderForm.value.total_send > 0) || this.senderType === 3;
  }

  get validSenderForm() {
    return this.senderForm.valid && this.validLoop() && this.validContacts() && this.validChat && this.validPost;
  }

  public showErrorsModal(message: Message): void {
    this.modalService.openModal('ModalSerrosContactsComponent', {
      sender: message.sender,
      Service: this.Service
    });
  }

  public showResultsModal(message: Message): void {
    this.modalService.openModal('ModalResultContactsComponent', {
      sender: message.sender,
      Service: this.Service
    });
  }

  public isShowErros(message: Message): boolean {
    return Object.keys(message?.sender?.contacts_fatal || {}).length > 0;
  }

  public resetForm(): void {
    this.senderType = -1;
    this.senderForm.reset();
  }

  get activeAccounts(): SenderAccountToken[] {
    const arIds: number[] = [];
    return this.account$.value?.accounts?.filter((v) => {
      if (arIds.includes(v.telegram_id)) {
        return false;
      }
      arIds.push(v.telegram_id);
      return v.authorized;
    }) || [];
  }

  get floodAccounts(): SenderAccountToken[] {
    return this.activeAccounts?.filter((v) => {
      return v.flood_wait > 0 && v.flood_wait > Date.now() / 1000;
    });
  }

  openHelpChat(): void {
    const arServices = this.allMessengersService.getServicesFilter('isAuth', true).filter((v) => v.type.includes('telegram|')) as TelegramService[];
    if (arServices.length > 0) {
      arServices[0].getDetailInfo(this.helpChatId, false).subscribe((res) => {
        this.appService.openChat(this.helpChatId, 'telegram');
      }, error => {
        this.openHelpChatInTelegram();
      });
    } else {
      this.openHelpChatInTelegram();
    }
  }

  openHelpChatInTelegram(): void {
    // 'width=550, height=450'
    window.open(`https://t.me/${this.helpChatUserName}`, '_blank');
  }

  addHelpChat(chats: Chat[]) {
    const arServices = this.allMessengersService.getServicesFilter('isAuth', true).filter((v) => v.type.includes('telegram|'));
    if (arServices.length === 0) {
      return;
    }
    const text = 'Если у вас возникли сложности с инспользванием нашего сервиса или возникли предложения, напишите в область внизу ваш вопрос и мы с радостью Вам ответим в этом же чате!<br><b>Но для надежности, рекомендуем писать с личного аккаунта в телеграмм бота https://t.me/TeleSellerSupportBot</b>';
    const findChat = this.allService.arChat.find((chat) => chat.username === this.helpChatUserName);
    if (!findChat) {
      chats.unshift({
        id: this.helpChatUserName,
        name: {
          first: 'Техподдержка',
          last: ''
        },
        title: 'Техподдержка',
        username: this.helpChatUserName,
        service_type: arServices[0].type,
        is_pinned: true,
        is_support: true,
        type: 'support',
        last_message: {
          time: 9999999999999,
          text,
          text_list: 'Написать в техподдержку',
          chat_id: this.helpChatId,
          date: 9999999999999,
          id: 0,
          out: false
        }
      });
    } else {
      findChat.id = this.helpChatUserName;
      findChat.is_pinned = true;
      findChat.is_support = true;
      findChat.name = {
        first: 'Техподдержка',
        last: ''
      };
      findChat.title = 'Техподдержка';
      findChat.username = this.helpChatUserName;
      findChat.type = 'support';
    }
  }

  public isParsedChat(message: Message): boolean {
    return !!(message?.sender?.parsed_completed) && !message.sender?.parsed_status;
  }

  getDownloadUrlXml(id: string | number): string {
    return this.urlApi + '/api/sender/export/export-xls/' + id + '/users.xls';
  }

  getViewUrlXml(id: string | number): string {
    return 'https://docs.google.com/viewer?url=' + this.getDownloadUrlXml(id);
  }

  openParsed(type: string, id: string | number) {
    switch (type) {
      case 'xls':
        window.open(this.getViewUrlXml(id));
        break;
    }
  }

  downloadParsed(type: string, id: string | number) {
    switch (type) {
      case 'xls':
        this.allService.downloadFile(this.getDownloadUrlXml(id), false).subscribe((downloadInfo) => {

        });
        break;
    }
  }

  get messagePrice(): number {
    if (this.senderType === 1) {
      return 0.15;
    }
    return 1;
  }

  public fixStartDate() {
    if (this.senderForm.get('start_date').invalid) {
      this.senderForm.get('start_date').setValue(this.isoDate);
    }
  }

  get isoDate(): string {
    const currentDate = new Date();

    // Получаем текущий час и минуту
    const currentHour = currentDate.getHours();
    const currentMinute = currentDate.getMinutes();

    // Прибавляем 3 часа
    const targetHour = currentHour + 3;

    // Создаем новый объект даты с обновленным часом
    const targetDate = new Date(currentDate);
    targetDate.setHours(targetHour);

    // Устанавливаем минуты обратно в текущие минуты
    targetDate.setMinutes(currentMinute);

    // Получаем строку формата ISO, обрезаем до 16 символов
    return targetDate.toISOString().slice(0, 16);
  }

  public replySender(message: Message): void {
    this.snotifyService.clear();
    this.snotifyService.confirm(
      `Повтор нужен для повторяющихся рассылок, например в группы, получаетели рассылки получат повторно ваш текст. `,
      'Повторить отправку?',
      {
        timeout: 30000,
        titleMaxLength: 100,
        showProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        position: SnotifyPosition.centerTop,
        buttons: [
          {
            text: 'Да',
            action: () => {
              this.http.post(`${this.urlApi}/api/sender/reply/${message.id}/?account_id=${this.account$.value.id}`, {})
                .subscribe((data: any) => {
                  this.notifierWrapService.notify('success', 'Рассылка перезапущена, добавлен один цикл. Вы можете нажать изенить и указать любое кол-во циклов и интервал между ними');
                  setTimeout(() => {
                    message.sender.completed = false;
                    message.sender.current_count = 0;
                    message.sender.error_count = 0;
                    this.updateMessage(message.id);
                  }, 3000);
                });
            },
            bold: false
          },
          {
            text: 'Нет'
          }
        ]
      }
    );
  }

  public pauseSender(message: Message): void {
    this.http.post(`${this.urlApi}/api/sender/pause/${message.id}/?account_id=${this.account$.value.id}`, {}).subscribe((data: any) => {
      message.sender.pause = data.pause;
      if (data.pause) {
        this.notifierWrapService.notify('info', 'Рассылка приостановлена, что бы продолжить, нажмите еще раз.');
      } else {
        this.notifierWrapService.notify('success', 'Рассылка продолжена, что бы приостановить, нажмите еще раз.');
      }
      this.dcService.detectChanges$.next('message-' + message.id);
      setTimeout(() => {
        this.updateMessage(message.id);
      }, 5000);
    }, error => {
      if (message.sender.pause) {
        this.notifierWrapService.notify('error', 'Возобновление не удалось, попробуйте позже.');
      } else {
        this.notifierWrapService.notify('error', 'Приостановка не удалась, попробуйте позже.');
      }

    });
  }

  public deleteSender(message: Message): void {
    this.snotifyService.clear();
    this.snotifyService.confirm(
      '',
      `Удалить рассылку №${message.id}?`,
      {
        timeout: 30000,
        titleMaxLength: 100,
        showProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        position: SnotifyPosition.centerTop,
        buttons: [
          {
            text: 'Нет'
          },
          {
            text: 'Удалить',
            action: () => {
              this.http.delete(`${this.urlApi}/api/sender/delete/${message.id}/?account_id=${this.account$.value.id}`, {}).subscribe((data: any) => {
                this.allService.reloadChat$.next();
                this.notifierWrapService.notify('success', 'Рассылка удалена');

              }, error => {
                this.notifierWrapService.notify('error', 'Удаление не удалась, попробуйте позже.');
              });
            },
            bold: false
          }
        ]
      }
    );
  }

  public isRepry(message: Message): boolean {
    return message?.sender?.completed && !message?.sender?.parsed_chat;
  }

  public isPause(message: Message): boolean {
    return message?.sender?.pause && !message?.sender?.completed;
  }

  public isEdit(message: Message): boolean {
    return true; // !message?.sender?.completed;
  }

  public isNotPause(message: Message): boolean {
    return !message?.sender?.pause && !message?.sender?.completed;
  }

  get senderAddForm(): boolean {
    return this._senderAddForm;
  }

  set senderAddForm(val) {
    this._senderAddForm = val;
    this.dcService.detectChanges$.next('messages-scroll');
  }

  openSenderChat() {
    this._openChatId = this.type;
    this.appService.openChat({
      id: this.type,
      type: 'sender',
      service_type: this.type,
      name: {
        first: 'Список',
        last: 'рассылок'
      }
    }, this, true);
  }

  openInfoChat() {
    const chatId = '@teleseller_chat';
    const arServices = this.allMessengersService.getServicesFilter('isAuth', true)
      .filter((v) => v.type.includes('telegram|')) as TelegramService[];
    if (arServices.length > 0) {
      arServices[0].getDetailInfo(chatId, false).subscribe((res) => {
        this.appService.openChat(chatId, arServices[0].type);
      }, error => {
        this.openInfoChatInTelegram();
      });
    } else {
      this.openInfoChatInTelegram();
    }
  }

  openInfoChatInTelegram(): void {
    // 'width=550, height=450'
    window.open(`https://t.me/teleseller_chat`, '_blank');
  }

  openSenderPartnerList() {
    this._openChatId = 'partner';
    this.appService.openChat({
      id: 'partner',
      type: 'partner',
      service_type: this.type,
      name: {
        first: 'Список',
        last: 'пользователей'
      }
    }, this, true);
  }

  toggleSenderChat() {
    if (this._openChatId) {
      delete this._openChatId;
      this.allService.isCloseChat = true;
      return;
    } else {
      this.openSenderChat();
    }
  }

  get showSenderSettingsTab(): boolean {
    return this.parseType === 2 || this.senderType !== 3;
  }

  showVirtualGuid() {
    this.senderAddForm = true;
    this.shepherdService.start();
  }

  get authTokens(): string[] {
    const arTokens = [];
    this.allMessengersService.getServicesFilter('isAuth', true).forEach((Service: IMessengerConnector) => {
      if (Service.type.indexOf('telegram') > -1 && Service.token) {
        arTokens.push(Service.token);
      }
    });
    return arTokens;
  }

  copyLnkPartner(): void {
    this.allService.copyTextToClipboard(this.linkPartner);
    this.isCopyPartnerLink = true;
    this.dcService.detectChanges$.next('messages-scroll');
  }

  senderRegisterSendCode(email: string) {
    return this.http.post(this.telegramService.urlApi + `/api/sender/register/code`, {email}, this.telegramService.httpOptions);
  }

  senderRegisterCheckCode(data: any) {
    data.partner = this.partnerId;
    return this.http.post(this.telegramService.urlApi + `/api/sender/register/check`, data, this.telegramService.httpOptions);
  }

  senderRegister(data: any) {
    data.partner = this.partnerId;
    return this.http.post(this.telegramService.urlApi + `/api/sender/register`, data, this.telegramService.httpOptions);
  }

  senderAuthorize(data: any) {
    return this.http.post(this.telegramService.urlApi + `/api/sender/auth`, data, this.telegramService.httpOptions);
  }

  senderForgot(data: any) {
    return this.http.post(this.telegramService.urlApi + `/api/sender/forgot`, data, this.telegramService.httpOptions);
  }

  senderArend(data: any) {
    return this.http.post(this.telegramService.urlApi + `/api/sender/arend`, data, this.telegramService.httpOptions);
  }

  private setPartnerId() {
    const searchParams = new URLSearchParams(location.search);
    const id = searchParams.get('p');
    if (id) {
      localStorage.setItem('partner', id);
    }
  }

  get partnerId(): number {
    if (localStorage.getItem('partner')) {
      return parseInt(localStorage.getItem('partner'), 10);
    }
    return 0;
  }

  get linkPartner(): string {
    return location.protocol + '//' + location.host + `?p=${this.account$.value.id}`;
  }

  /*private logoutAccounts() {
    setTimeout(() => {
      const accountsIds = this.activeAccounts.map((v) => v.telegram_id);
      if (accountsIds.length > 1) {
        const accounts = this.allMessengersService.arServicesAuthorized.find((Service) => {
          return Service.arProfile?.id === telegramId
        });
        accountsIds.map((telegramId) => {
            // account.telegram_id//
          // this.authService.logout();
        });
      }
    }, 5000);
  }*/
  public isAdmin(): boolean {
    return !!(
      this.account$.value?.id
      && [836, 837, 874, 876, 877, 875, 874, 902, 1431, 1434, 1437, 1470, 1420, 1439].includes(this.account$.value?.id)
    );
  }

  ymAddParams() {
    if (this.account$.value.id) {
      const yaParams = {
        id: this.account$.value.id,
        email: this.account$.value.email,
        balance: this.account$.value.balance,
        accounts: this.allMessengersService.arServicesAuthorized?.length,
        senders: this.senderService.arHistory?.length,
        errors: this.interfaceService.errorsCount,
      };
      ym(environment.yaCounterId, 'params', yaParams);
      log('Add yaParams', yaParams);
    }
  }

  calcTariffPrice(promoCode: string = '', period = 1) {
    let price = this.tariffPrice;
    const promo = this.promoCodes[promoCode];
    if (period === 1) {
      switch (promo?.type) {
        case 'percent':
          price = Math.round(price - ((price * promo.value) / 100));
          break;
      }
    } else {
      const sale = this.arSale[period];
      price = price - ((price * sale) / 100);
    }

    return price;
  }

  paidTariff(full: 'test' | 'start' | 'full', promoCode = '', period = 1) {
    promoCode = promoCode.toUpperCase();
    const price = this.calcTariffPrice(promoCode, period) * period;
    this.http.get(`${this.telegramService.urlApi}/api/sender/freekassa/url/?order_id=${this.account$.value.id}_${full}_${period}&order_amount=${price}&currency=RUB`)
      .subscribe((res: {
        url: string
      }) => {
        console.log('payUrl', res.url);
        window.open(res.url);
      });
  }

  expiredTariff(offset = 86400000): boolean {
    const tariffPaid = this.account$.value?.tariff_paid;
    if (!tariffPaid) {
      return false;
    }
    const tariffPaidDate = new Date(tariffPaid);
    const oneDayAgo = new Date(new Date().getTime() + offset);
    // console.log('tariffPaidDate', tariffPaidDate, oneDayAgo);
    return tariffPaidDate <= oneDayAgo;
  }
}

